import { ModuleWithProviders } from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {HomeComponent} from './home/home.component';
import {AboutComponent} from './about/about.component';
import {LandingComponent} from './landing/landing.component';
import {LoginComponent} from './login/login.component';
import {SignupComponent} from './signup/signup.component';
import {SpotDetailComponent} from './spot-detail/spot-detail.component';
import {NewSpotComponent} from './new-spot/new-spot.component';
import {OverviewComponent} from './overview/overview.component';


const appRoutes: Routes = [
  {
    path:'',
    component: LandingComponent,
    pathMatch: 'full'
  },
  {
    path: 'about',
    component:AboutComponent
  },
  {
    path: 'home',
    component:HomeComponent,
    children: [
      { path: '', redirectTo: 'overview', pathMatch: 'full' },
      { path: 'overview', component: OverviewComponent},
      { path: 'spotDetail/:id', component: SpotDetailComponent },
      { path: 'newSpot', component: NewSpotComponent }
    ]
  },
  {
    path: 'login',
    component:LoginComponent
  },
  {
    path: 'signup',
    component: SignupComponent
  },
  {
    path: '**',
    redirectTo: ''
  }
];

export const router: ModuleWithProviders = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// ./src/app/app.router.ts